import Request from "../helpers/request";
import * as url from "../helpers/url_helper";

const areaSearchApiCall = (e, setAreaData) => {
  const value = !e ? "a" : e;
  Request.get(`${url.GET_SEARCH_AREA_URL}?keyword=${value}`)
    .then((res) => {
      var area = [];
      for (var i = 0; i < res.data?.data?.length; i++) {
        var ele = res.data.data[i];
        area.push({ label: ele.name, value: ele.id });
      }
      setAreaData(area);
    })
    .catch((err) => {
      console.error("Error fetching data:", err);
    });
};

const userSearchApiCall = (e, setUserData, type, isRemoveAllUsers) => {
  const value = !e ? "a" : e;
  Request.get(`${url.GET_SEARCH_USER_URL}?keyword=${value}&type=${type}`)
    .then((res) => {
      var user = [];
      if (type === 3 && !isRemoveAllUsers) {
        user.push({ label: "All User", value: "all" });
      } else {
        user = [];
      }
      for (var i = 0; i < res.data?.data?.length; i++) {
        var ele = res.data.data[i];

        user.push({
          label: `
                    ${ele.firstname} ${ele.lastname} | 
                    ${
                      ele.email ? `${ele.email} ${ele?.mobile ? "|" : ""} ` : ""
                    }  
                    ${ele?.mobile ? `${ele?.mobile}` : ""}`,
          value: ele.id,
        });
      }

      setUserData(user);
    })
    .catch((err) => {
      console.error("Error fetching data:", err);
    });
};

const premiseSearchApiCall = (e, setPremisesNameList) => {
  const value = e ? `?keyword=${e}` : `?keyword=`;
  Request.get(`${url.GET_SEARCH_PREMISE_URL}${value}`)
    .then((res) => {
      var premises = [];
      for (var i = 0; i < res.data?.data?.length; i++) {
        var ele = res.data.data[i];
        premises.push({
          label: `${ele.firstname} ${ele.lastname} | ${ele.email} `,
          value: ele.id,
        });
      }
      setPremisesNameList(premises);
    })
    .catch((err) => {
      console.error("Error fetching data:", err);
    });
};

const citySearchApiCall = (e, setCityData) => {
  const value = !e ? "a" : e;
  Request.get(`${url.GET_SEARCH_CITY_URL}?keyword=${value}`)
    .then((res) => {
      var city = [];
      for (var i = 0; i < res.data?.data?.length; i++) {
        var ele = res.data.data[i];
        city.push({ label: ele.name, value: ele.id });
      }
      setCityData(city);
    })
    .catch((err) => {
      console.error("Error fetching data:", err);
    });
};

const allPremisesSearchApiCall = (e, setPremisesNameList) => {
  const value = !e ? "a" : e;
  Request.get(`${url.ALL_PREMISES_SEARCH_URL}?keyword=${value}`)
    .then((res) => {
      var allPremisesName = [];
      for (var i = 0; i < res.data?.data?.length; i++) {
        var ele = res.data.data[i];
        allPremisesName.push({
          label: `${ele.firstname} ${ele.lastname} ${
            ele.email ? `| ${ele.email}` : ""
          }`,
          value: ele.id,
        });
      }
      setPremisesNameList(allPremisesName);
    })
    .catch((err) => {
      console.error("Error fetching data:", err);
    });
};

const hardwareListApiCall = (setHardwareList) => {
  Request.get(`${url.GET_HARDWARE_LIST}`)
    .then((res) => {
      var allHardwareName = [];
      for (var i = 0; i < res.data?.data?.length; i++) {
        var ele = res.data.data[i];
        allHardwareName.push({
          label: `${ele.name}(${ele.hardwareVersion})`,
          value: ele.id,
        });
      }
      setHardwareList(allHardwareName);
    })
    .catch((err) => {
      console.error("Error fetching data:", err);
    });
};

const firmwareSearchApiCall = (hardwareId, e, setFirmwareList) => {
  Request.get(
    `${url.SEARCH_FIRMWARE_LIST}?hardwareId=${hardwareId}&keyword=${e}`
  )
    .then((res) => {
      var allFirmware = [];
      for (var i = 0; i < res.data?.data?.length; i++) {
        var ele = res.data.data[i];
        allFirmware.push({
          label: `${ele.firmwareVersion}(${ele.isStable ? "Stable" : "Test"})`,
          value: ele.id,
        });
      }
      setFirmwareList(allFirmware);
    })
    .catch((err) => {
      console.error("Error fetching data:", err);
    });
};

const stateSearchApiCall = (e, setStateList) => {
  const value = e ? e : "all";
  Request.get(`${url.GET_SEARCH_STATE_URL}?keyword=${value}`)
    .then((res) => {
      var stateData = [];
      stateData.push({ label: "All", value: "all" });
      for (var i = 0; i < res.data?.data?.length; i++) {
        var ele = res.data.data[i];
        stateData.push({ label: ele.name, value: ele.id });
      }
      setStateList(stateData);
    })
    .catch((err) => {
      console.error("Error fetching data:", err);
    });
};

const cityFromStateSearch = (e, setCityList, searchStateValue) => {
  const value = e ? e : "a";
  Request.get(
    `${url.GET_SEARCH_CITY_FROM_STATE_URL}?keyword=${value}&stateId=${searchStateValue}`
  )
    .then((res) => {
      var cityData = [];
      cityData.push({ label: "All", value: "all" });
      for (var i = 0; i < res.data?.data?.length; i++) {
        var ele = res.data.data[i];
        cityData.push({ label: ele.name, value: ele.id });
      }

      setCityList(cityData);
    })
    .catch((err) => {
      console.error("Error fetching data:", err);
    });
};

const webUserSearchApiCall = (e, setWebUserList) => {
  const value = e ? e : "a";
  Request.get(`${url.SEARCH_WEB_USER_URL}?keyword=${value}`)
    .then((res) => {
      var userList = [];
      userList.push({ label: "All", value: "all" });
      if (res.data?.data?.length > 0) {
        for (var i = 0; i < res.data?.data?.length; i++) {
          var ele = res.data.data[i];
          const combineKey = [
            `${ele?.firstname} ${ele?.lastname}`,
            ele.email,
            ele?.mobile,
            ele?.type === 0
              ? "Admin"
              : ele?.type === 1
              ? "Sub Admin"
              : ele?.type === 4
              ? "Hotel User"
              : "",
          ];
          userList.push({
            label: combineKey?.join(" | "),
            value: ele.id,
          });
        }
      } else {
        userList.push({ label: "All", value: "all" });
      }
      setWebUserList(userList);
    })
    .catch((err) => {
      console.error("Error fetching data:", err);
    });
};

export {
  areaSearchApiCall,
  userSearchApiCall,
  premiseSearchApiCall,
  citySearchApiCall,
  allPremisesSearchApiCall,
  hardwareListApiCall,
  firmwareSearchApiCall,
  stateSearchApiCall,
  cityFromStateSearch,
  webUserSearchApiCall,
};
